import {
  HANDLE_PICKUP_FORM_FIELD_CHANGE,
  UPDATE_PICKUP_FORM,
  PICKUP_FROM_SUBMISSION,
  PICKUP_FROM_SUBMISSION_SUCCESS,
  PICKUP_FROM_SUBMISSION_ERROR,
  CHECK_ERROR_IN_CURRENT_STEP
} from "../actions/pickupForm";
import { RESET_API_RETRY_COUNT } from "../actions/ui";
import { apiRequest } from "../actions/api";

import mapObject from "../../utils/mapObject";

import { evaluateCondition, prepareSubmission } from "form-metadata-2";

import lotDetailsMapper from "../../serviceMappers/lot";
import { submitFormServicePath } from "../../config";

export const handleFieldsChange = ({
  dispatch,
  getState
}) => next => action => {
  next(action);

  if (action.type === HANDLE_PICKUP_FORM_FIELD_CHANGE) {
    const prevState = getState().pickupForm;
    var { [action.payload.key]: value, ...errors } = prevState.errors;
    const newProperties = {
      value: action.payload.value,
      error: action.payload.error,
      showError: true
    };
    let newState = {
      ...prevState,
      fields: {
        ...prevState.fields,
        [action.payload.key]: {
          ...prevState.fields[action.payload.key],
          ...newProperties
        }
      },
      errors: {
        ...errors
      }
    };

    if (action.payload.key in newState.fieldChangeEffects) {
      mapObject(
        newState.fieldChangeEffects[action.payload.key],
        (props, field) => {
          newState = {
            ...newState,
            fields: {
              ...newState.fields,
              [field]: {
                ...newState.fields[field],
                ...mapObject(props, (condition, key) => {
                  return evaluateCondition(
                    condition,
                    newState.fields,
                    lotDetailsMapper
                  );
                })
              }
            }
          };
        }
      );
    }
    dispatch({ type: UPDATE_PICKUP_FORM, payload: newState });
   // dispatch({ type: CHECK_ERROR_IN_CURRENT_STEP });

  }
};

export const handlePickUpFormSubmission = ({
  dispatch,
  getState
}) => next => action => {
  next(action);
  let uuid = getState().lot.uuid;

  if (action.type === PICKUP_FROM_SUBMISSION) {
    const fieldsState = getState().pickupForm.fields;
    let submitData = { data: prepareSubmission(lotDetailsMapper, fieldsState) };
    dispatch(
      apiRequest(
        "POST",
        submitFormServicePath(uuid),
        submitData,
        PICKUP_FROM_SUBMISSION_SUCCESS,
        PICKUP_FROM_SUBMISSION_ERROR,
        10,
        true
      )
    );
  }

  if (action.type === PICKUP_FROM_SUBMISSION_SUCCESS) {
    dispatch({ type: RESET_API_RETRY_COUNT });
  }
};

export const pickupFormMdl = [handleFieldsChange, handlePickUpFormSubmission];



// WEBPACK FOOTER //
// ./src/redux/middleware/pickupForm.js